import React, { FC } from "react";
import Tooltip from "../../../../components/Tooltip/Tooltip";
import { useGetLogoImageQuery } from "../../../../api/imageAPI";
import Icon from "../../../../components/Icon/Icon";
import { IconColorE, IconSizeE } from "../../../../models/enums";
import useQueryParams from "../../../../utils/hooks/useQueryParams";
import { categoryOptions } from "../../../../utils/helpers/categoryOptions";
import { clss } from "../../../../utils/helpers/styleHelpers";

import styles from "./broadcasterLogo.module.scss";

type BroadcasterLogoPropTypes = {
  id: number;
  name: string;
  className?: any;
  handleChose?: (id: number) => void;
};

/**
 * Loading image src once and use in different places without refetching from server
 */

const BroadcasterLogo: FC<BroadcasterLogoPropTypes> = ({
  id,
  name,
  className,
  handleChose,
}) => {
  const { data } = useGetLogoImageQuery({ id });
  const { addQueryParam } = useQueryParams();
  const options = categoryOptions();

  const handleClick = (category: number, searchText: string | number) => {
    handleChose
      ? handleChose(id)
      : addQueryParam({
          filterType: options[category].value,
          filter: searchText,
        });
  };

  return (
    <Tooltip text={name} withoutTranslation>
      <div
        className={clss([styles.imageWrapper, className])}
        onClick={() => handleClick(3, name)}
      >
        {data ? (
          <img src={data} alt={`broadcaster ${id} logo`} />
        ) : (
          <Icon
            name="loading"
            color={IconColorE.LIGHT_GRAY}
            size={IconSizeE.S}
          />
        )}
      </div>
    </Tooltip>
  );
};

export default BroadcasterLogo;
